/* eslint-disable @typescript-eslint/no-non-null-asserted-optional-chain */
/* eslint-disable prefer-const */
/* eslint-disable @typescript-eslint/no-extra-non-null-assertion */
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable no-useless-catch */
/* eslint-disable @typescript-eslint/no-explicit-any */
import {
  ThemeProvider,
  Typography,
  Link,
  AppHeaderBackButton,
  Box,
  Icon,
  AlertTypography,
} from '@ace-clublabs/shared-component-library';
/* eslint-disable no-restricted-globals */
import { StoredPayments } from '@ace-clublabs/payments-component-library';
import { useEffect, useState } from 'react';
import { IPayWithStoredPaymentRequest, IStoredPaymentMethod } from '../types';
import {
  CardBrand,
  IProcessPaymentWithManifestRequest,
  PaymentType,
  ProductType,
  TransactionStatus,
} from '@ace-clublabs/payment-types';
import { useNavigate } from 'react-router-dom';
import { Pages } from '../shared/pages';
import { sources } from '../api/sources';
import { useGlobalState } from '../shared/state';
import { PaymentMethodsAuthorizationModal } from '../components/PaymentMethodsAuthorizationModal';
import UrlHelper from '../utils/urlHelper';
import { TOKEN_KEY_PAYMENTS, MANIFEST_TTL_MS } from '../constants';
import Cookies from 'universal-cookie';
import { UtagHelper } from '../utils/utagHelper';
import { getAccessToken } from '../utils/authHelper';
import { ErrorSeverity, ErrorType, IPaymentDetails } from '../shared/types';
import Header from '../components/Header';
import Spinner from '../components/Spinner';
import LogCannon from '@ace-clublabs/log-cannon';
import { ProcessPaymentHelper } from '../utils/processPaymentHelper';
import { PaymentReview } from '../containers/PaymentReview';
import Processing from '../components/Processing';
import parse from 'html-react-parser';
import { Environments, getEnvironmentFromHost } from '../api/endpoints';
import { getPaymentPBLTaggingFlow, getPaymentPBLTaggingInsurancePolicies, getTermsUrl } from '../utils/methods';
import { getMyAccountURL } from '@ace-clublabs/payments-helper';
import dayjs from 'dayjs';
import { validatePBLExpiration } from '../utils/pblExpirationHelper';
import { IGetAdyenSession, ISubmitAdyenTokenRequest } from '../api/contracts';

declare const google: any;

const cookies = new Cookies();

export const PaymentMethods: React.FC = () => {
  const [isProcessing, setProcessing] = useState(false);
  const [isLoading, setLoading] = useState(true);
  const [accessToken] = useState(cookies.get(TOKEN_KEY_PAYMENTS));
  const [paymentMethods, setPaymentMethods] = useState([] as IStoredPaymentMethod[]);
  const [failedPaymentMethod, setFailedPaymentMethod] = useState({} as IStoredPaymentMethod);
  const [title, setTitle] = useState('');
  const [paymentMethodsAlertText, setPaymentMethodsAlertText] = useState(
    {} as { text: React.ReactNode; severity: 'info' | 'error' | 'warning' }
  );
  const [manifestId] = useGlobalState('manifestId');
  const [manifest] = useGlobalState('manifest');
  const [, setPaymentType] = useGlobalState('paymentType');
  const [scheduledDate] = useGlobalState('scheduledDate');
  const [redirectMap, setRedirected] = useGlobalState('redirectMap');
  const [, setPaymentMethodsSkipped] = useGlobalState('paymentMethodsSkipped');
  const [sessionId] = useGlobalState('sessionId');
  const [customerId] = useGlobalState('customerId');
  const [payByLinkData] = useGlobalState('payByLinkData');
  const [, setError] = useGlobalState('error');
  const [manifestTimestamp] = useGlobalState('manifestTimestamp') || [];
  const [isPaymentReview, setPaymentReview] = useState(false);
  const [paymentDetails, setPaymentDetails] = useState({}) as [IPaymentDetails, any];
  const [selectedPaymentIdFromLocal, setSelectedPaymentId] = useState('');
  const [isScheduled] = useGlobalState('isScheduled');
  const [, setPaymentProcessing] = useGlobalState('paymentProcessing');
  const [isMobileApp] = useGlobalState('isMobileApp') || [];

  const APPLE_PAY_VERSION = 3;
  const navigate = useNavigate();

  useEffect(() => {
    validatePBLExpiration(payByLinkData, navigate, setError);
  }, [payByLinkData, navigate, setError]);

  const {
    clubCode,
    redirect,
    testRegion,
    hidePaymentMethods,
    storedPaymentAlertText,
    clientConfig,
    renderTsAndCs,
    renderPaymentMethods,
    amount,
    autoPay,
    tags,
    paymentType,
    tokenOnly,
  } = manifest || {};
  const { returnUrl } = redirect || {};

  const renderNoChargeAlert = clientConfig?.renderNoChargeAlert && amount === 0;
  const allowedPaymentTypes = clientConfig?.allowedPaymentTypes || [];
  const subtitle = clientConfig?.paymentMethodSubtitle;
  const allowCards =
    allowedPaymentTypes.includes(PaymentType.CreditOrDebit) ||
    allowedPaymentTypes.includes(PaymentType.DebitOnly) ||
    allowedPaymentTypes.includes(PaymentType.Prepaid);

  const onlyDebit =
    !allowedPaymentTypes.includes(PaymentType.CreditOrDebit) &&
    (allowedPaymentTypes.includes(PaymentType.DebitOnly) || allowedPaymentTypes.includes(PaymentType.Prepaid));

  const storePaymentOnly = amount === 0 && autoPay === false && paymentType !== undefined;
  const isSinglePaymentType =
    manifest?.paymentType != undefined ||
    (allowedPaymentTypes.includes(PaymentType.Echeck) && allowedPaymentTypes.length === 1) ||
    (!allowedPaymentTypes.includes(PaymentType.Echeck) &&
      !allowedPaymentTypes.includes(PaymentType.Google) &&
      !allowedPaymentTypes.includes(PaymentType.Apple));

  const PAYMENT_STATUS_UNKNOWN_TEXT = (
    <AlertTypography>
      Payment submitted but there was an issue confirming it — please check{' '}
      <Link href={getMyAccountURL()} target="_blank" rel="noopener noreferrer">
        My Account
      </Link>{' '}
      before retrying to avoid a duplicate charge.
    </AlertTypography>
  );

  /**
   * Determines if payment methods should be skipped and navigation should go directly to PaymentPage.
   * Used both for navigation logic and for conditional tag firing to prevent race conditions.
   */
  const shouldSkipPaymentMethods = (
    allowedStoredPaymentMethodsLength: number,
    isSinglePaymentTypeValue: boolean,
    storePaymentOnlyValue: boolean
  ): boolean => {
    return (allowedStoredPaymentMethodsLength === 0 && isSinglePaymentTypeValue) || storePaymentOnlyValue;
  };

  const getPaymentTypeText = () => {
    if (allowCards && allowedPaymentTypes.includes(PaymentType.Echeck)) {
      return 'card or e-check.';
    } else if (allowCards) {
      return 'card.';
    } else if (allowedPaymentTypes.includes(PaymentType.Echeck)) {
      return 'e-check.';
    } else {
      return 'payment method.';
    }
  };

  const getNewPaymentOptions = () => {
    const _newPaymentOptions: PaymentOption[] = [];
    if (allowCards) {
      _newPaymentOptions.push(
        onlyDebit
          ? {
              id: PaymentType.DebitOnly,
              value: PaymentType.DebitOnly,
              display: 'Add a debit card',
            }
          : {
              id: PaymentType.CreditOrDebit,
              value: PaymentType.CreditOrDebit,
              display: 'Add a credit/debit card',
            }
      );
    }

    if (allowedPaymentTypes.includes(PaymentType.Echeck)) {
      _newPaymentOptions.push({
        id: PaymentType.Echeck,
        value: PaymentType.Echeck,
        display: 'Add an e-check',
      });
    }

    if (allowedPaymentTypes.includes(PaymentType.Google) && !isScheduled && !isMobileApp) {
      _newPaymentOptions.push({
        id: PaymentType.Google,
        value: PaymentType.Google,
        display: (
          <Box className="payment-type google-pay">
            Google Pay
            <Icon iconName="google-pay-logo" />
          </Box>
        ),
      });
    }

    if (
      allowedPaymentTypes.includes(PaymentType.Apple) &&
      !isScheduled &&
      (window as any).ApplePaySession &&
      (window as any).ApplePaySession?.canMakePayments()
    ) {
      _newPaymentOptions.push({
        id: PaymentType.Apple,
        value: PaymentType.Apple,
        display: (
          <Box className="payment-type apple-pay">
            Apple Pay
            <Icon iconName="apple-pay-logo" />
          </Box>
        ),
      });
    }

    return _newPaymentOptions.length > 0 ? _newPaymentOptions : undefined;
  };

  const getPaymentMethods = async () => {
    let allStoredPaymentMethods: IStoredPaymentMethod[] = [];
    const allowedStoredPaymentMethods: IStoredPaymentMethod[] = [];

    try {
      if (renderPaymentMethods) {
        setLoading(true);
        try {
          allStoredPaymentMethods = await sources.getPaymentMethods(testRegion);
        } catch (e: any) {
          if (e.type === ErrorType.SESSION_TIMEOUT) {
            await getAccessToken();
            allStoredPaymentMethods = await sources.getPaymentMethods(testRegion);
          } else {
            throw e;
          }
        }
        allStoredPaymentMethods.forEach((method) => {
          const isHidden = hidePaymentMethods?.find((hpm) => {
            return (
              ((hpm?.paymentType === PaymentType.CreditOrDebit || hpm?.paymentType === PaymentType.DebitOnly) &&
                hpm?.last4 === method?.last4 &&
                hpm?.brand === method?.brand) ||
              (hpm?.paymentType === PaymentType.Echeck && hpm?.accountLast4 === method?.accountLast4)
            );
          });

          let scheduledAfterExpiration;
          if (method.expiryDate && isScheduled && scheduledDate) {
            const methodExpiration = method.expiryDate.split('/');
            const month = methodExpiration[0];
            const year = methodExpiration[1];
            const methodExp = new Date(parseInt(year), parseInt(month), 0);
            const scheduled = new Date(scheduledDate);
            scheduledAfterExpiration = dayjs(scheduled).isAfter(dayjs(methodExp));
          }

          if (
            allowedPaymentTypes.includes(method.paymentType) &&
            !method?.isExpired &&
            !isHidden &&
            method.id !== failedPaymentMethod.id &&
            !scheduledAfterExpiration
          ) {
            allowedStoredPaymentMethods.push(method);
          }
        });
      }

      if (shouldSkipPaymentMethods(allowedStoredPaymentMethods.length, isSinglePaymentType, storePaymentOnly)) {
        const resolvedPaymentType = storePaymentOnly ? paymentType! : allowedPaymentTypes[0];
        setPaymentType(resolvedPaymentType);

        setPaymentMethodsSkipped(true);

        const isCardPaymentTypeForPage = [
          PaymentType.CreditOrDebit,
          PaymentType.DebitOnly,
          PaymentType.Prepaid,
        ].includes(resolvedPaymentType);

        // Match PaymentPage: FirstData CardForm only when not using Adyen card fields.
        const paymentPageNeedsFirstDataCardSdk =
          isCardPaymentTypeForPage && (isScheduled || !clientConfig?.renderAdyenCardForm);

        const completeSkippedMethodsNavigation = () => {
          setLoading(isSinglePaymentType);
          navigate(Pages.PaymentPage);
        };

        if (!paymentPageNeedsFirstDataCardSdk) {
          LogCannon.blast('Skipping FirstData SDK wait; PaymentPage does not use FirstData card form', {
            manifestId,
            sessionId,
            customerId,
            resolvedPaymentType,
            isScheduled,
            renderAdyenCardForm: clientConfig?.renderAdyenCardForm,
          });
          completeSkippedMethodsNavigation();
        } else {
          let pollCount = 0;
          const maxPollAttempts = 60;
          const firstDataTimer = setInterval(() => {
            pollCount++;

            if ((window as any).firstdata) {
              clearInterval(firstDataTimer);
              LogCannon.blast('FirstData SDK loaded successfully', {
                pollAttempts: pollCount,
                totalWaitTimeMs: pollCount * 500,
                manifestId,
                sessionId,
                customerId,
              });
              completeSkippedMethodsNavigation();
            } else if (pollCount === maxPollAttempts) {
              clearInterval(firstDataTimer);
              LogCannon.blast('FirstData SDK exceeded expected load time', {
                pollAttempts: pollCount,
                totalWaitTimeMs: pollCount * 500,
                manifestId,
                sessionId,
                customerId,
                severity: 'WARNING',
              });
              setPaymentMethodsSkipped(false);
              setLoading(false);
              setPaymentMethodsAlertText({
                text: "We couldn't load the payment form. Check your connection, disable content blockers for this site if you use them, then try Continue again.",
                severity: 'error',
              });
            }
          }, 500);
        }
      } else {
        tag(false, allowedStoredPaymentMethods.length);
      }
    } catch (e: any) {
      LogCannon.blast('exception occured getting stored payments', e);
    } finally {
      setPaymentMethods(allowedStoredPaymentMethods);
      setLoading((allowedStoredPaymentMethods.length === 0 && isSinglePaymentType) || storePaymentOnly);
    }
  };

  const handleRedirect = (url: string) => {
    setRedirected({ ...redirectMap, [manifestId!]: url });
    navigate(`/redirect/${manifestId}`);
  };

  const makePaymentWithStoredMethodCall = async (selectedPaymentId?: string) => {
    try {
      const isManifestStale = !!manifestTimestamp && Date.now() - manifestTimestamp > MANIFEST_TTL_MS;
      if (isManifestStale) {
        throw { type: ErrorType.SESSION_TIMEOUT, message: 'Manifest is stale' };
      }
      const payWithStoredPaymentRequest: IPayWithStoredPaymentRequest = {
        tokenId: selectedPaymentIdFromLocal || selectedPaymentId!,
        manifestId: manifestId!,
        scheduledDate,
      };

      setProcessing(true);
      setPaymentProcessing(true);

      const payResult = await ProcessPaymentHelper.payWithStoredPayment(payWithStoredPaymentRequest);
      if (
        payResult.status === TransactionStatus.Succeeded ||
        payResult.status === TransactionStatus.PartialSuccess ||
        payResult.status === TransactionStatus.Scheduled
      ) {
        const { transactionId } = payResult;
        const returnURL = UrlHelper.addQueryParam(returnUrl!, { transactionId });
        handleRedirect(returnURL);
      } else {
        setProcessing(false);
        setPaymentReview(false);
        setTitle(
          `We couldn't use the selected payment method. Please add or choose a different ${getPaymentTypeText()}`
        );
      }
    } catch (e: any) {
      if (e.type === ErrorType.PROCESSING_ERROR) {
        setProcessing(false);
        setPaymentReview(false);
        setTitle(
          `We couldn't use the selected payment method. Please add or choose a different ${getPaymentTypeText()}`
        );
        const errorMessage = 'ERROR: Processing Error for Selected Payment Method';
        if (typeof e === 'string') {
          LogCannon.blast(`${errorMessage}: ${e}`);
        } else {
          LogCannon.blast(errorMessage, e as object);
        }
      } else if (e.type === ErrorType.INVALID_PAYMENT_METHOD_ERROR) {
        setProcessing(false);
        setPaymentReview(false);
        const { paymentType, last4, id: failedPaymentId } = e?.data || {};
        setPaymentMethodsAlertText({
          text: `Your ${paymentType} ending in ${last4} was removed from your saved payment methods. Please re-add it or use a new payment method.`,
          severity: 'error',
        });
        const failedPayment = paymentMethods.find((pm) => pm.id === failedPaymentId);
        if (failedPayment?.id) {
          setFailedPaymentMethod(failedPayment);
        }
        const errorMessage = 'ERROR: Invalid Payment Method Error for Selected Payment Method';
        if (typeof e === 'string') {
          LogCannon.blast(`${errorMessage}: ${e}`);
        } else {
          LogCannon.blast(errorMessage, e as object);
        }
      } else if (e?.type === ErrorSeverity.SOFT && e?.message === 'payment_status_unknown') {
        setProcessing(false);
        setPaymentReview(false);
        LogCannon.blast('Payment status unknown after stored payment — showing inline message', {
          component: 'PaymentMethods',
          error: typeof e === 'string' ? `${e}` : e,
          manifestId,
        });
        setPaymentMethodsAlertText({ text: PAYMENT_STATUS_UNKNOWN_TEXT, severity: 'warning' });
      } else {
        const isExpired = e?.type === ErrorType.SESSION_TIMEOUT;
        const errorMessage = 'ERROR: Fail to Make Payment with Selected Payment Method';

        if (isExpired) {
          setError({ errorType: ErrorType.SESSION_TIMEOUT, errorMessage: e?.message ?? '' });
        }
        LogCannon.blast(isExpired ? 'Navigating to Session Error' : 'Navigating to Error', {
          component: 'PaymentMethods',
          errorMessage,
          error: typeof e === 'string' ? `${e}` : e,
          manifestId,
          ...(isExpired && { manifestExpiredAfterMs: Date.now() - manifestTimestamp!, expiredManifestId: manifestId }),
        });
        navigate(Pages.Error);
      }
    }
  };

  const handleGooglePayment = async () => {
    const allowedCardAuthMethods = ['PAN_ONLY', 'CRYPTOGRAM_3DS'];
    const allowedCardNetworks = ['AMEX', 'DISCOVER', 'INTERAC', 'JCB', 'MASTERCARD', 'VISA'];
    const merchantInfo = {
      merchantId: 'BCR2DN4TUOE3FKAL',
      ...{ merchantName: 'AAA Payments' },
    };
    const transactionInfo = {
      countryCode: 'US',
      currencyCode: 'USD',
      totalPriceStatus: 'FINAL',
      totalPrice: amount!?.toFixed(2),
    };

    // Gateway-specific: Get tokenization specification
    let tokenizationSpecification: any;
    let adyenSession: IGetAdyenSession | null = null;

    try {
      adyenSession = await sources.getAdyenSession(manifestId!, { paymentType: PaymentType.Google });
    } catch (error) {
      LogCannon.blast('ERROR: Failed to fetch Adyen session for Google Pay', { error, manifestId });
      setProcessing(false);
      setTitle(`We couldn't process your payment. Please try again or select another payment method.`);
      return;
    }
    tokenizationSpecification = {
      type: 'PAYMENT_GATEWAY',
      parameters: {
        gateway: 'adyen',
        gatewayMerchantId: adyenSession.adyen.merchantAccount,
      },
    };

    const getGooglePaymentDataRequest = (): any => ({
      apiVersion: 2,
      apiVersionMinor: 0,
      allowedPaymentMethods: [
        {
          type: 'CARD',
          parameters: {
            allowedAuthMethods: allowedCardAuthMethods,
            allowedCardNetworks,
            allowCreditCards: allowedPaymentTypes.includes(PaymentType.CreditOrDebit),
            allowPrepaidCards: allowedPaymentTypes.includes(PaymentType.Prepaid),
            billingAddressRequired: true,
            billingAddressParameters: {
              format: 'MIN',
            },
          },
          tokenizationSpecification,
        },
      ],
      merchantInfo,
      transactionInfo,
      callbackIntents: ['PAYMENT_AUTHORIZATION'],
    });

    // Process payment based on gateway
    const processPayment = async (paymentData: any): Promise<string> => {
      const { name: cardHolderName, postalCode: zipCode } = paymentData?.paymentMethodData?.info?.billingAddress || {};
      const { tokenizationData, info } = paymentData.paymentMethodData || {};
      const { cardNetwork, cardDetails } = info || {};

      let processPaymentBody: IProcessPaymentWithManifestRequest;

      const walletData = {
        walletType: 'googlepay' as const,
        paymentMethodData: {
          type: 'googlepay' as const,
          googlePayToken: tokenizationData?.token,
          googlePayCardNetwork: cardNetwork,
        },
        cardInfo: {
          brand: cardNetwork || '',
          last4: cardDetails || '',
          holderName: cardHolderName || '',
          postalCode: zipCode || '',
        },
      };

      processPaymentBody = {
        manifestId,
        paymentType: PaymentType.Google,
        adyenData: {
          sessionId: adyenSession!.adyen.sessionId,
          walletData,
        },
      } as unknown as IProcessPaymentWithManifestRequest;

      if (tokenOnly) {
        LogCannon.blast(`Storing Adyen Google Pay token (tokenOnly)`, { manifestId });
        const tokenPayload: ISubmitAdyenTokenRequest = {
          adyen: {
            sessionId: adyenSession!.adyen.sessionId,
            walletData,
          },
        };
        await sources.submitAdyenToken(adyenSession!.adyen.sessionId, tokenPayload);
        window.location.href = returnUrl!;
        return 'token-only';
      }

      LogCannon.blast(`Processing Adyen Google Pay payment`, { manifestId, gateway: 'adyen' });
      return await ProcessPaymentHelper.startDigitalWalletPayment(processPaymentBody);
    };

    // Payment authorization callback
    const onPaymentAuthorized = async (paymentData: any): Promise<any> => {
      try {
        const transactionId = await processPayment(paymentData);
        if (transactionId !== 'token-only') {
          pollForTransactionStatusAndRedirect(transactionId);
        }
        return { transactionState: 'SUCCESS' };
      } catch (error: any) {
        setProcessing(false);
        if (error?.type === ErrorSeverity.SOFT) {
          setTitle(`We couldn't process your payment. Please select another payment method.`);
        } else {
          const errorMessage = `ERROR: Failed to process Adyen Google Payment`;
          LogCannon.blast('Navigating to Error', {
            component: 'PaymentMethods',
            errorMessage,
            error: typeof error === 'string' ? `${error}` : error,
            manifestId,
          });
          navigate(Pages.Error);
        }
        return {
          transactionState: 'ERROR',
          error: {
            intent: 'PAYMENT_AUTHORIZATION',
            message: error?.message,
            reason: 'PAYMENT_DATA_INVALID',
          },
        };
      }
    };

    // Initialize Google Pay client
    const _googlePayEnv =
      getEnvironmentFromHost(window.location.hostname) === Environments.prod ? 'PRODUCTION' : 'TEST';

    let paymentsClient: any = null;
    const getGooglePaymentsClient = () => {
      if (paymentsClient === null) {
        paymentsClient = new google.payments.api.PaymentsClient({
          environment: _googlePayEnv,
          paymentDataCallbacks: {
            onPaymentAuthorized,
          },
        });
      }
      return paymentsClient;
    };

    // Trigger Google Pay
    const paymentDataRequest = getGooglePaymentDataRequest();
    const client = getGooglePaymentsClient();
    client.loadPaymentData(paymentDataRequest).catch((err: any) => {
      if (err.statusCode === 'CANCELED' || err.name === 'AbortError') {
        setProcessing(false);
      } else {
        LogCannon.blast(`Adyen Google Pay loadPaymentData failed`, err);
        setProcessing(false);
      }
    });
  };

  const handleApplePayment = () => {
    if (!(window as any).ApplePaySession) {
      return;
    }

    const merchantCapabilities = ['supports3DS'];
    if (onlyDebit) {
      merchantCapabilities.push('supportsDebit');
    }
    const request = {
      countryCode: 'US',
      currencyCode: 'USD',
      merchantCapabilities,
      supportedNetworks: ['visa', 'masterCard', 'amex', 'discover'],
      requiredBillingContactFields: ['postalAddress', 'name'],
      total: {
        label: 'Payment',
        type: 'final',
        amount: amount?.toFixed(2),
      },
      ...(autoPay
        ? {
            recurringPaymentRequest: {
              paymentDescription: 'AAA AutoPay',
              regularBilling: {
                label: 'AAA AutoPay',
                amount: amount?.toFixed(2),
                type: 'final',
                paymentTiming: 'recurring',
                recurringPaymentStartDate: new Date(),
                recurringPaymentIntervalUnit: 'year',
                recurringPaymentIntervalCount: 1,
                // recurringPaymentEndDate: new Date('2024-01-01T00:00:00'),
              },
              managementURL: 'https://app.ace.aaa.com/payments/manage-autopay',
            },
          }
        : {}),
    };

    try {
      const session = new (window as any).ApplePaySession(APPLE_PAY_VERSION, request);
      session.begin();

      session.onvalidatemerchant = async () => {
        try {
          const merchantSession = await sources.authorizeApplePay('adyen');
          session.completeMerchantValidation(merchantSession);
        } catch (error) {
          console.error('[APPLE_PAY_DEBUG] onvalidatemerchant FAILED:', error);
        }
      };

      session.onpaymentmethodselected = async (event: any) => {
        try {
          const update = {
            newTotal: request.total,
          };
          session.completePaymentMethodSelection(update);
        } catch (err) {
          console.error('[APPLE_PAY_DEBUG] onpaymentmethodselected FAILED:', err);
        }
      };

      session.onpaymentauthorized = async (event: any) => {
        try {
          const { paymentData: cardData, paymentMethod } = event?.payment?.token || {};

          const { network: cardNetwork, displayName, type } = paymentMethod || {};

          const { givenName, familyName, postalCode: zipCode } = event.payment.billingContact || {};
          const cardHolderName = `${givenName} ${familyName}`;

          let processPaymentBody: IProcessPaymentWithManifestRequest;

          const walletData = {
            walletType: 'applepay' as const,
            paymentMethodData: {
              type: 'applepay' as const,
              applePayToken: JSON.stringify(cardData),
            },
            cardInfo: {
              brand: cardNetwork || '',
              last4: displayName?.slice(-4) || '',
              holderName: cardHolderName || '',
              postalCode: zipCode || '',
            },
          };

          processPaymentBody = {
            manifestId,
            paymentType: PaymentType.Apple,
            adyenData: {
              walletData,
            },
          } as unknown as IProcessPaymentWithManifestRequest;

          LogCannon.blast(`Processing Adyen Apple Pay payment`, {
            manifestId,
            gateway: 'adyen',
          });

          if (tokenOnly) {
            LogCannon.blast(`Storing Adyen Apple Pay token (tokenOnly)`, { manifestId });
            const appleAdyenSession = await sources.getAdyenSession(manifestId!, { paymentType: PaymentType.Apple });
            const applePayAdyenSessionId = appleAdyenSession.adyen.sessionId;
            const tokenPayload: ISubmitAdyenTokenRequest = {
              adyen: {
                sessionId: applePayAdyenSessionId,
                walletData,
              },
            };
            await sources.submitAdyenToken(applePayAdyenSessionId, tokenPayload);
            session.completePayment({ status: (window as any).ApplePaySession.STATUS_SUCCESS });
            window.location.href = returnUrl!;
            return;
          }

          const transactionId = await ProcessPaymentHelper.startDigitalWalletPayment(processPaymentBody);

          pollForTransactionStatusAndRedirect(transactionId);

          session.completePayment({ status: (window as any).ApplePaySession.STATUS_SUCCESS });
        } catch (error: any) {
          console.error('[APPLE_PAY_DEBUG] onpaymentauthorized FAILED:', error);
          console.error(
            '[APPLE_PAY_DEBUG] onpaymentauthorized error type:',
            typeof error,
            '| error.type:',
            error?.type,
            '| error.message:',
            error?.message,
            '| error.name:',
            error?.name
          );
          console.error(
            '[APPLE_PAY_DEBUG] ApplePaySession.STATUS_FAILURE value:',
            (window as any).ApplePaySession?.STATUS_FAILURE
          );
          LogCannon.blast('exception occured apple payment', error);
          setProcessing(false);
          if (error.type === ErrorSeverity.SOFT) {
            setTitle(`We couldn't process your payment. Please select another payment method.`);
          } else {
            const errorMessage = `ERROR: Failed to process Adyen Apple Payment`;
            LogCannon.blast('Navigating to Error', {
              component: 'PaymentMethods',
              errorMessage,
              error: typeof error === 'string' ? `${error}` : error,
              manifestId,
            });
            navigate(Pages.Error);
          }
          try {
            session.completePayment({
              status: (window as any).ApplePaySession.STATUS_FAILURE,
            });
          } catch (completePaymentError: any) {
            console.error(
              '[APPLE_PAY_DEBUG] session.completePayment(FAILURE) threw:',
              completePaymentError?.name,
              completePaymentError?.message
            );
          }
        }
      };

      session.oncancel = () => {
        setProcessing(false);
      };
    } catch (err) {
      console.error('[APPLE_PAY_DEBUG] session creation/begin failed:', err);
      setProcessing(false);
    }
  };

  const handleSubmit = async (selectedPaymentId: string) => {
    setPaymentMethodsAlertText({} as any);
    setSelectedPaymentId(selectedPaymentId);

    const isNewMethod = [PaymentType.CreditOrDebit, PaymentType.DebitOnly, PaymentType.Echeck].includes(
      selectedPaymentId as PaymentType
    );

    if (selectedPaymentId === PaymentType.Google) {
      tag(true);
      setPaymentType(selectedPaymentId as PaymentType);
      setProcessing(true);
      handleGooglePayment();
      return;
    }

    if (selectedPaymentId === PaymentType.Apple) {
      tag(true);
      setPaymentType(selectedPaymentId as PaymentType);
      setProcessing(true);
      handleApplePayment();
      return;
    }

    if (isNewMethod) {
      setPaymentType(selectedPaymentId as PaymentType);

      navigate(Pages.PaymentPage);
    } else if (clientConfig?.renderPaymentReview && amount && amount > 0) {
      const currentMethod = paymentMethods.find((pm) => pm.id === selectedPaymentId);

      await setPaymentDetails({
        paymentType: currentMethod?.paymentType,
        card:
          currentMethod?.paymentType === PaymentType.CreditOrDebit ||
          currentMethod?.paymentType === PaymentType.DebitOnly ||
          currentMethod?.paymentType === PaymentType.Prepaid
            ? { last4: currentMethod?.last4, brand: currentMethod?.brand }
            : undefined,
        echeck:
          currentMethod?.paymentType === PaymentType.Echeck
            ? { last4: currentMethod?.accountLast4, routingNumber: currentMethod?.routingNumber }
            : undefined,
      });

      setPaymentReview(true);
    } else makePaymentWithStoredMethodCall(selectedPaymentId);
  };

  const tag = (isDigital: boolean, storedPaymentMethodsLength?: number) => {
    const allowedStoredPaymentMethodsLength = storedPaymentMethodsLength ?? paymentMethods?.length ?? 0;

    if (isDigital && customerId && sessionId) {
      const digitalPaymentTags = {
        channel: 'my account',
        subchannel1: 'sms',
        page: 'my account:sms:digital payment',
        sessionid: sessionId,
        custID: customerId,
        ...(tags?.flow && { flow: tags.flow }),
        ...(tags?.ins_policy && { ins_policy: tags.ins_policy }),
      };

      UtagHelper.tag(digitalPaymentTags);
    } else if (
      !isDigital &&
      tags &&
      !shouldSkipPaymentMethods(allowedStoredPaymentMethodsLength, isSinglePaymentType, storePaymentOnly)
    ) {
      const { channel, subchannel1, subchannel2 } = tags || {};
      const pageName = 'payment method';
      const page = subchannel2
        ? `${channel}:${subchannel1}:${subchannel2}:${pageName}`
        : `${channel}:${subchannel1}:${pageName}`;
      UtagHelper.tag({ ...tags, page, sessionid: sessionId });
    }
  };

  const goBackMethod = () => {
    navigate(-1);
  };

  const pollForTransactionStatusAndRedirect = async (transactionId: string) => {
    try {
      const { transactionStatus } = (await ProcessPaymentHelper.waitForCompleteTransaction(transactionId))!;

      if (
        transactionStatus === TransactionStatus.Succeeded ||
        transactionStatus === TransactionStatus.PartialSuccess ||
        transactionStatus === TransactionStatus.Scheduled
      ) {
        const returnURL = UrlHelper.addQueryParam(returnUrl!, { transactionId });
        handleRedirect(returnURL);
      } else {
        setProcessing(false);
        setPaymentReview(false);
        setTitle(`We couldn't process your payment. Please select another payment method.`);
      }
    } catch (e: any) {
      setProcessing(false);
      if (e?.type === ErrorSeverity.SOFT && e?.message === 'payment_status_unknown') {
        LogCannon.blast('Payment status unknown after digital wallet payment — showing inline message', {
          component: 'PaymentMethods',
          error: typeof e === 'string' ? `${e}` : e,
          manifestId,
        });
        setPaymentMethodsAlertText({ text: PAYMENT_STATUS_UNKNOWN_TEXT, severity: 'warning' });
      } else {
        const errorMessage = 'ERROR: Fail to Poll for Transaction Status and Redirect';
        LogCannon.blast('Navigating to Error', {
          component: 'PaymentMethods',
          errorMessage,
          error: typeof e === 'string' ? `${e}` : e,
          manifestId,
        });
        navigate(Pages.Error);
      }
    }
  };

  useEffect(() => {
    const handlePageShow = (event: PageTransitionEvent) => {
      if (event.persisted) {
        window.location.reload();
      }
    };

    window.addEventListener('pageshow', handlePageShow);

    return () => {
      window.removeEventListener('pageshow', handlePageShow);
    };
  }, []);

  useEffect(() => {
    if (renderNoChargeAlert) {
      setPaymentMethodsAlertText({
        text: `You won't be charged today—your payment info is being saved for Auto Pay.`,
        severity: 'info',
      });
    }
  }, []);

  const gotoUrl = (url: string) => {
    window.location.href = url;
  };

  useEffect(() => {
    const redirectUrl = redirectMap[manifestId!];
    if (redirectUrl) {
      gotoUrl(redirectUrl);
    }
  }, []);

  useEffect(() => {
    if (customerId && sessionId) {
      const flow = getPaymentPBLTaggingFlow(payByLinkData);
      const insurancePolicies = getPaymentPBLTaggingInsurancePolicies(payByLinkData);

      const smsPaymentMethodTags = {
        channel: 'my account',
        subchannel1: 'sms',
        page: 'my account:sms:payment method',
        sessionid: sessionId,
        custID: customerId,
        flow,
        ins_policy: insurancePolicies,
      };

      UtagHelper.tag(smsPaymentMethodTags);
    }
  }, [customerId, sessionId]);

  useEffect(() => {
    if (renderPaymentMethods && !accessToken) {
      getAccessToken();
    }
    getPaymentMethods();
  }, [failedPaymentMethod]);

  return (
    <>
      {isLoading && <Spinner />}
      {!isProcessing && isPaymentReview && (
        <PaymentReview
          amount={amount!}
          paymentDetails={paymentDetails}
          scheduledDate={scheduledDate}
          pit={manifest?.pit ? { ...manifest.pit } : undefined}
          onSubmit={makePaymentWithStoredMethodCall}
          onBack={() => setPaymentReview(false)}
        />
      )}
      {isProcessing && <Processing />}
      {!isLoading && !isProcessing && !isPaymentReview && (
        <PaymentMethodsView
          clubCode={clubCode!}
          newPaymentOptions={getNewPaymentOptions()}
          storedPayments={paymentMethods}
          handleSubmit={handleSubmit}
          goBackMethod={goBackMethod}
          title={title}
          subtitle={subtitle}
          primaryAlertText={paymentMethodsAlertText as { text: string; severity: 'info' | 'error' | 'warning' }}
          alertText={storedPaymentAlertText}
          hidePaymentMethods={hidePaymentMethods}
          renderPaymentReview={clientConfig?.renderPaymentReview!}
          renderTsAndCs={renderTsAndCs}
        />
      )}
    </>
  );
};

export type PaymentOption = {
  id: string | number;
  value: string | number;
  display: any;
  header?: string;
};

export interface PaymentMethodViewProps {
  clubCode: string;
  storedPayments: IStoredPaymentMethod[];
  newPaymentOptions?: PaymentOption[];
  handleSubmit: (e: any) => void;
  goBackMethod: (e: any) => void;
  title?: string;
  subtitle?: string;
  primaryAlertText?: { text: React.ReactNode; severity: 'info' | 'error' | 'warning' };
  alertText?: string;
  hidePaymentMethods?: [{ paymentType: PaymentType; last4?: string; accountLast4?: string; brand?: CardBrand }];
  renderPaymentReview: boolean;
  renderTsAndCs?: { render: boolean; productType: ProductType };
}

export const PaymentMethodsView: React.FC<PaymentMethodViewProps> = (props) => {
  const {
    clubCode,
    storedPayments,
    newPaymentOptions,
    handleSubmit,
    goBackMethod,
    title,
    subtitle,
    primaryAlertText,
    alertText,
    hidePaymentMethods,
    renderTsAndCs,
  } = props;

  const [showPaymentAuthorization, setShowPaymentAuthorization] = useState(false);
  const [showTcAndCs, setShowTcAndCs] = useState(false);

  let storedPaymentOptions = storedPayments.filter((sp) => sp.status != 'pending-delete') as any[];
  if (hidePaymentMethods && hidePaymentMethods.length > 0) {
    hidePaymentMethods.forEach((hpm) => {
      storedPaymentOptions = storedPaymentOptions.filter((sp) => {
        const isCreditOrDebitMatch =
          hpm.paymentType === PaymentType.CreditOrDebit &&
          sp.paymentType === hpm.paymentType &&
          sp.last4 === hpm.last4 &&
          sp.brand === hpm.brand;

        const isEcheckMatch =
          hpm.paymentType === PaymentType.Echeck &&
          sp.paymentType === hpm.paymentType &&
          sp.accountLast4 === hpm.accountLast4;

        const hideStoredPaymentMethod = isCreditOrDebitMatch || isEcheckMatch;

        return !hideStoredPaymentMethod;
      });
    });
  }
  storedPaymentOptions = storedPaymentOptions.map((sp) => {
    return {
      storePaymentId: sp.id,
      paymentType: sp.paymentType,
      cardBrand: sp.paymentType === PaymentType.Echeck ? undefined : sp.brand,
      last4: sp.paymentType === PaymentType.Echeck ? sp.accountLast4! : sp.last4!,
      expired: sp.isExpired!,
      expiryDate: sp.expiryDate!,
    };
  });

  const cardBrandOrder = {
    visa: 1,
    americanexpress: 2,
    mastercard: 3,
    discover: 4,
  };

  const sortedPaymentOptions = storedPaymentOptions.slice().sort((a, b) => {
    if (a.paymentType < b.paymentType) {
      return -1;
    }
    if (a.paymentType > b.paymentType) {
      return 1;
    }

    const aCardBrandOrder = cardBrandOrder[a.cardBrand as keyof typeof cardBrandOrder];
    const bCardBrandOrder = cardBrandOrder[b.cardBrand as keyof typeof cardBrandOrder];

    if (aCardBrandOrder < bCardBrandOrder) {
      return -1;
    }
    if (aCardBrandOrder > bCardBrandOrder) {
      return 1;
    }

    return 0;
  });

  return (
    <div className="payment-method-view inner-container">
      {
        <>
          <Header />
          <AppHeaderBackButton id="back-button" onClick={goBackMethod} />
          <ThemeProvider>
            <StoredPayments
              title={title ? title : undefined}
              subTitle={subtitle ? subtitle : undefined}
              newPaymentOptions={newPaymentOptions}
              storedPayments={sortedPaymentOptions}
              onSubmit={(e: any) => {
                handleSubmit(e.storedPaymentOption);
              }}
              primaryAlertText={
                primaryAlertText as { text: string; severity: 'info' | 'error' | 'warning' } | undefined
              }
              alertText={alertText ? <span>{parse(alertText)}</span> : undefined}
            ></StoredPayments>
          </ThemeProvider>
          {!renderTsAndCs?.render && (
            <>
              <Typography variant="b2Regular" id="authorization-text">
                By clicking Continue, I hereby state that I am an authorized user for the above payment method, and have
                read and agree to the{' '}
                <Link
                  data-id="payment-authorization-link"
                  variant="b2Regular"
                  component="button"
                  sx={{ verticalAlign: 'baseline' }}
                  onClick={() => {
                    setShowPaymentAuthorization(true);
                  }}
                >
                  Payment Authorization
                </Link>
                .
              </Typography>{' '}
            </>
          )}
          {renderTsAndCs?.render && (
            <Typography variant="b2Regular" className="terms-and-conditions">
              By clicking Continue, I hereby enroll in Auto Pay with the above payment method I have selected, and have
              read and agree to the{' '}
              <Link
                data-id="terms-conditions-link"
                id="terms-conditions-link"
                variant="b2Regular"
                href={getTermsUrl()}
                target="_blank"
                sx={{ verticalAlign: 'baseline' }}
              >
                Terms & Conditions
              </Link>{' '}
              <Typography variant="b2Regular" sx={{ display: 'inline-block' }}>
                and{' '}
              </Typography>
              <Link
                data-id="terms-conditions-link"
                variant="b2Regular"
                component="button"
                sx={{ verticalAlign: 'baseline' }}
                onClick={() => {
                  setShowPaymentAuthorization(true);
                }}
              >
                Payment Authorization
              </Link>
              .
            </Typography>
          )}
        </>
      }{' '}
      {showPaymentAuthorization && (
        <PaymentMethodsAuthorizationModal
          ctaText="Continue"
          handleClose={() => {
            setShowPaymentAuthorization(false);
          }}
        ></PaymentMethodsAuthorizationModal>
      )}
    </div>
  );
};
